import { render, staticRenderFns } from "./notificationBar.vue?vue&type=template&id=570ebcfe&scoped=true&"
import script from "./notificationBar.vue?vue&type=script&lang=js&"
export * from "./notificationBar.vue?vue&type=script&lang=js&"
import style0 from "./notificationBar.vue?vue&type=style&index=0&id=570ebcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ebcfe",
  null
  
)

export default component.exports